<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="Permohonan Pemeriksaan Kebuntingan">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis" label="ID Premis" />
              <z-select style="margin:5px; " v-model="pencarian.lkp_status_id" :items="lkp_status" label="Status" />
            </w-flex>
          </w-form>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
        <z-table title="Senarai Permohonan Pemeriksaan Kebuntingan" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
            <template #button v-if="$zutil.anyRole(['1', '2', '5'])">
                <w-button dark class="green--bg ml1" :route="$route('pd.permohonan.form',0)" >
                    <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
                </w-button>
            </template>
          <template #header-label="{ header, label, index }">
            <template v-if="header.key == 'action'">
              <!-- <w-icon xs>fal fa-pencil</w-icon> -->
              Tindakan
            </template>
            <template v-else>
              {{ label }}
            </template>
          </template>
          <template #item-cell.action="{ item, label, header, index }">
            <w-flex class="flex justify-center">
              <template v-if="item.lkp_status_id==31 && $zutil.anyRole(['7', '8', '9', '10'])">
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                 <w-button class="mr2" v-on="on" bg-color="success" @click="onSuccess(1, item.id)"><div style="width: 8px"></div> 
                     <w-icon md class="mr2">fal fa-check-circle</w-icon>
                 </w-button>
                 </template>
                Terima
               </w-tooltip> &nbsp;
              <br>
              <w-tooltip md top color="white" bg-color="black" >
                  <template #activator="{ on }">
                    <w-button class="mr2" v-on="on" bg-color="error" @click="DTindakan(item, 2)"><div style="width: 8px"></div> 
                        <w-icon md class="mr2">fal fa-times-circle</w-icon>
                    </w-button>
                  </template>
                  Tolak
               </w-tooltip> &nbsp;
               <br>
               <w-tooltip md top color="white" bg-color="black" >
                  <template #activator="{ on }">
                     <w-button class="mr2" v-on="on" bg-color="warning" @click="DTindakan(item, 3)"><div style="width: 8px"></div> 
                        <w-icon md class="mr2">fal fa-exchange</w-icon>
                     </w-button>
                  </template>
                  Tukar Juruteknik/Jurusuntik
               </w-tooltip> &nbsp;
              </template>
              <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                    <w-button  bg-color="info" v-on="on" v-if="(item.lkp_status_id ==18||item.lkp_status_id ==21)&& $zutil.anyRole(['1', '2', '5'])" :route="$route('pd.permohonan.form',0)+'?salin='+item.id" class="be fs-2"><div style="width: 8px"></div> 
                      <w-icon md class="mr2">fal fa-copy</w-icon> 
                    </w-button>
               </template>
               Salin
               </w-tooltip>
              <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                    <w-button  bg-color="warning" v-on="on" v-if="item.lkp_status_id ==19 && $zutil.anyRole(['1', '2', '5'])" :route="$route('pd.permohonan.form',item.id)" class="be fs-2"><div style="width: 8px"></div> 
                       <w-icon md class="mr2">fal fa-pencil</w-icon>
                    </w-button>
                  </template>
                  Kemaskini
                </w-tooltip> 
               &nbsp;
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                    <inertia-link v-if="item.lkp_status_id!=21" :href="$route('pd.permohonan.semakan.show', item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                      <w-icon md class="mr2">fal fa-eye</w-icon>
                    </inertia-link>
                 </template>
                  Papar
                </w-tooltip>
                &nbsp;
            </w-flex>
          </template>
        </z-table>
      </div>
      <w-dialog
          v-model="dialog.show"
          :fullscreen="dialog.fullscreen"
          width="900"
          :persistent="dialog.persistent"
          :persistent-no-animation="dialog.persistentNoAnimation"
          title-class="primary-dark1--bg white">
            <template #title>
               <template v-if="dialog_form.tindakan == 3">
                  <w-icon class="mr2">fal fa-exchange</w-icon>
                  Tukar Juruteknik/Jurusuntik
               </template>
               <template v-else>
                  <w-icon class="mr2">fal fa-times-circle</w-icon>
                  Tolak
               </template>
            </template>
         <template v-if="dialog_form.tindakan == 3">
            <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td><b>TARIKH / MASA MOHON</b></td>
                     <td><b> : </b></td>
                     <td>{{dialog_form.tarikh_mohon}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>NO. PERMOHONAN</b></td>
                     <td><b> : </b></td>
                     <td>{{dialog_form.no_permohonan}}</td>
                  </tr>
                  </tbody>
               </table>
              </div>
              <div class="mx2"></div>
              <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td><b>PENTERNAK / NO TELEFON</b></td>
                     <td><b> : </b></td>
                     <td>{{dialog_form.nama_premis}} / {{dialog_form.no_tel_premis}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>ID PREMIS / NAMA PREMIS</b></td>
                     <td><b> : </b></td>
                     <td>{{dialog_form.premis}}</td>
                  </tr>
                  </tbody>
               </table>
            </div>
            </div>
         </template>

         <w-form 
            ref="form" 
            v-model="dialog.valid"
            @validate="tukarJuruteknik(dialog_form, dialog_form.id)"
            @success="success"
            >
            <template v-if="dialog_form.tindakan == 3">
               <z-select class="mt4" outline :items="juruteknik_list" label="Nama Juruteknik/Jurusuntik *"  v-model="dialog_form.juruteknik_id"  :validators="[validators.required]"/>
            </template>
            <w-textarea class="mt4" label="Catatan *" v-model="dialog_form.catatan" :validators="[validators.required]" outline />
         </w-form>
              

          
         <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
            <w-button 
            class="ml1" 
            :loading="dialog.loading"
            :disabled="dialog.valid === false"
            @click="$refs.form.validate()"
            >
              SIMPAN
            </w-button>
         </template>

          
        </w-dialog>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'pd.permohonan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Perkhidmatan PD', route: '/pd/permohonan' },
        { label: 'Semakan', route: '/pd/permohonan' },
      ],
      form : this.d_form,
      

      pencarian: {
         premis_id: '',
         lkp_art_id: '',
         lkp_status_id: '',
      },
      premis: [],
      lkp_art: [],
      lkp_status :[],
      juruteknik_list: [],
      dialog: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 1800,
          item: {name: '', email: '', mobile: ''}
      },
      
      
    }
  },
  methods: {
   DTindakan(item, tindakan){
      //tindakan '3' untuk tukar juruteknik
      //tindakan '2' untuk Padam
       this.dialog_form = {
           id : item.id,
           juruteknik_id : item.juruteknik_id,
           catatan : null,
           tindakan : tindakan,
           tarikh_mohon : item.tarikh_mohon,
           no_permohonan : item.no_permohonan,
           nama_premis : item.nama_premis,
           no_tel_premis : item.no_tel_premis,
           nama_pemohon : item.nama_pemohon,
           no_tel_pemohon : item.no_tel_pemohon,
           premis : item.premis,
       }
       this.getJuruteknik(item)
       this.dialog.show = true;
   },
   getJuruteknik(data){
      if(data.lkp_negeri_id !='' && data.lkp_art_id !='' ){
        this.$zcomm.get(this.api_service + 'lookup/juruteknik/'+data.lkp_negeri_id+'/2/0', {}).then(res => {
          this.juruteknik_list = res
        })
      }
    },
   capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
   },
   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_art', {}).then(res => {
        this.lkp_status = res
      })
    },

    getPremis(){
     this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
       this.premis = res
     })
   },
    getArt(){
      this.$zcomm.get(this.api_service + 'lookup/art', {}).then(res => {
        this.lkp_art = res
      })
    },
   tukarJuruteknik(tindakan, art_id){
      if(tindakan.catatan != null){
      this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            if (art_id > 0){
              this.$zcomm.update(this.resourceurl + '.tindakan', art_id, tindakan)
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                if (tindakan.tindakan==1) {
                    this.$zutil.notify("Berjaya disimpan", true);
                }else if (tindakan.tindakan==3) {
                    this.$zutil.notify("Berjaya ditukar", true);
                }else{
                  this.$zutil.notify("Berjaya ditolak", false);
                }
                this.$inertia.visit(this.$route(this.resourceurl+'.semakan'))
              })
            }
          }
        })
      }else{
        this.$zutil.notify("Catatan Wajib Diisi", false);
      }
      
   },
    onSuccess(tindakan, art_id){
      this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            if (art_id > 0){
              this.$zcomm.update(this.resourceurl + '.tindakan', art_id, {tindakan :tindakan})
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                if (tindakan==1) {
                    this.$zutil.notify("Berjaya disimpan", true);
                }else{
                  this.$zutil.notify("Berjaya ditolak", false);
                }
                this.$inertia.visit(this.$route(this.resourceurl+'.semakan'))
              })
            }
          }
        })
      
    },
    
  
  },

  watch: {

  },
  mounted() {
   this.getStatus();
   this.getPremis();
   this.getArt();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
